<template>
  <div id="levelItemRoot">
    <div id="leftPart">
      <img v-if="rebateItem['typeType'] == '6'" id="showRebateImg" src="~assets/img/SdkV3/GrabRebateIcon.png" />
      <img v-else id="showRebateImg" src="~assets/img/SdkV3/RebateIcon.png" />
    </div>
    <div v-if="rebateItem['typeType'] != '6'" id="middlePart">
      <label id="rebateValue">{{ rebateItem.name }}</label>
      <div id="rebateTipParent">
        <label id="rebateTip">{{ rebateItem.desc }}</label>
      </div>
    </div>
    <div v-else id="middlePart">
      <div style="display:flex;flex-direction:column;justify-content:center;height:100%;align-items: start;">
        <label style="font-size: x-small;color: #4B4646;transform: scale(0.95);" >{{ rebateItem.name }}</label>
        <label style="color:#F43107;font-weight:bolder;margin-top: 3px;margin-bottom: 2px;" >{{ rebateItem.amount }}元</label>
        <label v-show="rebateItem.limitall != '-1'" style="font-size: x-small;color: #4B4646;transform: scale(0.95);">共 {{ rebateItem.limitall }} 个</label>
      </div>
    </div>
    <div id="endPart">
      <!-- 已完成，也就是待领取状态 -->
      <div v-if="rebateItem.status == 1"
        style="display: flex;flex-direction: column;justify-content: center;align-items: center;">
        <!-- typeType 6：抢红包 -->
        <img v-if="rebateItem['typeType'] == '6'" id="receiveAction" src="~assets/img/SdkV3/GrabRebateOpen.png" style="width:43px;height:38px;" @click="grabRebate(rebateItem)"/>
        <!-- 非抢红包 -->
        <img v-else id="receiveAction" src="~assets/img/SdkV3/Receive.png"  @click="rebateReceive(rebateItem)"
          style="transform: scale(0.9);" :style="{'padding-top': (parseInt(rebateItem['timeout']) != -1 || parseInt(rebateItem['limit']) != -1)?'15px':'0px'}" />
        <span v-if="parseInt(rebateItem['timeout']) != -1 && rebateItem['typeType'] != '6'"
          style="color:#C8C8C8;font-size: xx-small; transform: scale(0.65);margin-top: -3px;">{{ count }}</span>
        <span v-if="parseInt(rebateItem['limit']) != -1 && rebateItem['typeType'] != '6'"
          style="color:#C8C8C8;font-size: xx-small; transform: scale(0.65);"
          :style="{'margin-top': '-2px'}"
          >{{ rebateItem['limit'] == '0' ? "已抢完" :
            "剩余：" + rebateItem['limit'] }}</span>
      </div>

      <!-- 未完成，也就是未达成条件的状态 -->
      <div v-else-if="rebateItem.status == 0"
        style="display: flex;flex-direction: column;justify-content: center;align-items: center;">
        <!-- 非抢红包 -->
        <span v-if="rebateItem['typeType'] != '6'" id="receiveAction" style="color:#C8C8C8;font-size: x-small;height:20px;line-height:20px;"
        :style="{'padding-top': (parseInt(rebateItem['timeout']) != -1 || parseInt(rebateItem['limit']) != -1)?'-15px':'0px'}">待完成</span> 
        <!-- 抢红包 -->
        <img v-else id="receiveAction" src="~assets/img/SdkV3/GrabRebateOpen.png" style="width:43px;height:38px;" @click="grabRebateNoMatch(rebateItem)"/>
        <!-- 非抢红包，才展示剩余多少个，或者时间倒计时 -->
        <span v-if="parseInt(rebateItem['timeout']) != -1 && rebateItem['typeType'] != '6'"
          style="color:#C8C8C8;font-size: xx-small; transform: scale(0.65);margin-top: -3px;">{{ count }}</span>
        <span v-if="parseInt(rebateItem['limit']) != -1 && rebateItem['typeType'] != '6'"
          style="color:#C8C8C8;font-size: xx-small; transform: scale(0.65);"
          :style="{'margin-top': '-2px'}"
          >{{ rebateItem['limit'] == '0' ? "已抢完" :
            "剩余：" + rebateItem['limit'] }}</span>
      </div>
      <!-- 已失效 -->
      <div v-else-if="rebateItem.status == 3" style="display: flex;flex-direction: column;justify-content: center;align-items: center;">
        <span v-if="rebateItem['typeType'] == '6'">
          <!-- 已领完 parseInt(rebateItem['limit']) == 0 -->
          <img v-if="showNoMore(rebateItem)" id="receiveAction" src="~assets/img/SdkV3/NoMore.png" style="width:43px;height:38px;" :style="{'padding-top': imgProblemPaddingTop}" @click="showGrabRebateLog(rebateItem)"/>
          <!-- 已失效 -->
          <img v-else id="receiveAction" src="~assets/img/SdkV3/GrabRebateOpen.png" style="width:43px;height:38px;" :style="{'padding-top': imgProblemPaddingTop}" @click="noMoreRebateCanOpenClick(rebateItem)"/>
        </span>
        <span v-else>
          <!-- 已领完  -->
          <img v-if="parseInt(rebateItem['limit']) == 0" id="receiveAction" src="~assets/img/SdkV3/NoMore.png" style="width:43px;height:38px;" :style="{'padding-top': imgProblemPaddingTop}" @click="showGrabRebateLog(rebateItem)"/>
          <!-- 已失效 -->
          <img v-else id="receiveAction" src="~assets/img/SdkV3/Lapse.png" style="width:43px;height:38px;" :style="{'padding-top': imgProblemPaddingTop}"/>
        </span>
        
      </div>
      <!-- 已领取，达成条件并且领取成功的状态 -->
      <div v-else style="display: flex;flex-direction: column;justify-content: center;align-items: center;">
        <img id="receiveAction" style="width:43px;height:38px;" src="~assets/img/SdkV3/Received.png" @click="showGrabRebateLog(rebateItem)"/>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  props: {
    rebateItem: null,
  },
  data() {
    return {
      count: '', //倒计时
      seconds: this.rebateItem['timeout'], // 10天的秒数
      timer: null,
      imgProblemPaddingTop: this.rebateItem['status'] == '3' ? "0":"15px",
    }
  },
  mounted: function () {
    // if (this.rebateItem['status'] == '3') {
    //   this.count = "已结束"
    //   return
    // }
    console.log(this.rebateItem);
    let timeout = this.rebateItem['timeout']
    if (timeout > 86400) {
      this.count = '剩余 ' + parseInt(timeout / (24 * 60 * 60)) + ' 天'
      return
    } else if (timeout == 0) {
      this.count = "已结束"
      return
    }
    this.seconds = this.rebateItem['timeout']
    this.Time()
  },
  methods: {
    // 已经抢完的红包，但是展示着 “开” 的图片，需要可以点击，然后标记已经点击
    noMoreRebateCanOpenClick(rebateItem){
      let clickRebateItemKey = this.$store.state.rid + rebateItem.confid + this.$store.state.commonParameters['hid']
      localStorage.setItem(clickRebateItemKey, true) //标记已经点击过
      this.$parent.showGrabRebateLog(rebateItem)
    },
    grabRebateNoMatch(rebateItem){
      // console.log("抢红包次数不足");
      // this.$store.commit('switchAlert', {"showOrHide": true, "alertMessage": "抢红包次数不足"})
      this.$parent.grabRebate(rebateItem)
    },
    rebateReceive(item) {
      // 调用父组件的方法 也就是 V3Rebate.vue中的 rebateReceive(item) 方法
      this.$parent.rebateReceive(item)
    },
    grabRebate(item) {
      // 调用父组件的方法 也就是 V3Rebate.vue中的 grabRebate(item) 方法
      this.$parent.grabRebate(item)
    },
    showGrabRebateLog(item) {
      // 调用父组件的方法 也就是 V3Rebate.vue中的 showGrabRebateLog(item) 方法
      if (item.typeType == '6') {
        this.$parent.showGrabRebateLog(item)
      }
    },
    // 天 时 分 秒 格式化函数
    countDown() {
      // let d = parseInt(this.seconds / (24 * 60 * 60))
      // d = d < 10 ? "0" + d : d
      let h = parseInt(this.seconds / (60 * 60) % 24);
      h = h < 10 ? "0" + h : h
      let m = parseInt(this.seconds / 60 % 60);
      m = m < 10 ? "0" + m : m
      let s = parseInt(this.seconds % 60);
      s = s < 10 ? "0" + s : s
      this.count = '剩余 ' + h + ':' + m + ':' + s + ''
    },
    //定时器没过1秒参数减1
    Time() {
      this.timer = setInterval(() => {
        this.seconds -= 1
        if (this.seconds == 0) {
          this.count = "已结束"
          clearInterval(this.timer)
          return
        }
        this.countDown()
      }, 1000)
    },
  },
  destroyed:function(){
    if (this.timer != null) {
      clearInterval(this.timer)
    }
  },
  computed: {
    showNoMore(){
      return rebateItem =>{
        let limit = parseInt(rebateItem['limit']) == 0
        // 是否点击过这个抢红包的项
        let clickRebateItemKey = this.$store.state.rid + rebateItem.confid + this.$store.state.commonParameters['hid']
        let clickThisRebate = localStorage.getItem(clickRebateItemKey)
        if (clickThisRebate) {
          // 已经点击过，应该展示 已抢完
          return limit
        }
        return false

      }
    }
  }
}
</script>

<style>
#levelItemRoot {
  position: relative;
  display: flex;
  flex-flow: row;
  width: 100%;
  height: auto;
  min-height: 50px;
  max-height: 100px;
  background-color: white;
  /* border-color: #EFEFEF; */
  border-radius: 10px;
  padding-top: 3px;
  padding-bottom: 3px;
  margin-top: 5px;
  margin-bottom: 5px;

  border-style: solid;
  border-width: 1px;
  border-color: #EFEFEF;
}

#leftPart {
  flex: 1;
  float: left;
  display: flex;
  /**/
  align-items: Center;
  /*垂直居中*/

  text-align: center;
  padding-left: 5px;
  justify-content: center;
  /* background-color: aqua; */
}

#middlePart {
  /* background-color: blue; */
  margin-left: 3px;
  flex: 7;
  flex-flow: row;
  position: relative;
  justify-content: flex-start;
}

#rebateValue {
  color: red;
  position: absolute;
  font-size: small;
  font-weight: bold;
  width: 100%;
  top: 20%;
}

#rebateTipParent {
  display: flex;
  justify-content: flex-start;
  /* background-color: chartreuse; */
  align-content: flex-start;
  position: absolute;
  width: 100%;
  top: 50%;
}

#rebateTip {
  /* background-color: violet; */
  display: inline-block;
  font-size: xx-small;
  width: 100%;
  left: 0%;
  transform: scale(0.95);
  transform-origin: 0;
  /* transform: scale(0.655); 用缩放来解决 */
  /* transform-origin: 0;避免缩放后无法靠左 */
  color: gray;
  margin-top: 5px;
}

#endPart {
  flex: 2;
  display: flex;
  justify-content: center;
  /*水平居中*/
  align-items: Center;
  /*垂直居中*/
  margin-right: 5px;
  /* background-color: yellow; */
}

#showRebateImg {
  z-index: 10;
  width: 40px;
  height: 42px;
  /* margin-left: 3px; */
  /* 解决图片拉伸问题 */
  object-fit: scale-down;
}

#receiveAction {
  z-index: 10;
  /* float: right; */
  /* padding-top: 15px; */
  /* height: 35px; */
  /* height: 68px; */
  width: 60px;
  /* line-height: 35px; */
  text-align: center;
  /* align-items: center; */
  vertical-align: end;
  /* 解决图片拉伸问题 */
  object-fit: scale-down;
  font-size: small;
}</style>


// WEBPACK FOOTER //
// src/views/SdkV3/rebate/RebateItem.vue